import './person-card.css';

const PersonCard = ({ field, img, name, jobTitle, type }) => {
	type = (type === 'big')? 'big' : '';
	return (
		<>
			<div className='person-card'>
				<div className="person-details">
					{ field && <h3>{ field }</h3> }
					{img && <img src={img} className={`img ${type} ${(name && jobTitle)? 'group' : ''}`} alt="person-img" />}
					<div className="text">
						{ name && <h4>{ name }</h4> }
						{ jobTitle && <p>{ jobTitle }</p> }
					</div>
				</div>
			</div>
		</>
	)
}

export default PersonCard
